// **Reactstrap
import {  FormFeedback, Label } from "reactstrap";
// ** Third Party
import Proptypes from "prop-types";
import { Controller } from "react-hook-form";
import classnames from "classnames";
// ** Custom Components
import InputPasswordToggle from "@components/fields/input-password-toggle";
import { useTranslation } from "react-i18next";

const PasswordField = (props) => {
    const { t } = useTranslation();

    const {
        errors,
        label,
        name,
        serverErrors = {},
        placeholder,
        autoFocus = false,
        disabled = false,
        control,
        className = "",
        required = false,
        id = ""
    } = props;

    const renderError = () => {
        const message = errors[name]?.message || serverErrors?.[name];
        return message && <FormFeedback data-cy={`error-${name}`}>{message}</FormFeedback>;
    };

    return (
        <div className={classnames("mb-1", { className })}>
            {label && (
                <Label htmlFor={name} data-cy={`label-${id}`}>
                    {t(label)}
                    {required && <span className="text-danger fw-bolder">*</span>}
                </Label>
            )}
            <Controller
                id={name} 
                name={name}
                control={control}
                render={({ field }) => (
                    <InputPasswordToggle
                        className="input-group-merge"
                        invalid={errors?.[name] && true}
                        placeholder={t(placeholder)}
                        {...field}
                        value={field.value}
                        name={name}
                        autoFocus={autoFocus}
                        disabled={disabled}/>
                )}/>

            {renderError()}
        </div>
    );
};

export default PasswordField;

PasswordField.propTypes = {
    errors: Proptypes.shape({}),
    label (props, propName) {
    // ** If label is defined and htmlFor is undefined throw error
        if (props[propName] && props["htmlFor"] === "undefined") {
            throw new Error("htmlFor prop is required when label prop is present");
        }
    },
    name        : Proptypes.string.isRequired,
    register    : Proptypes.shape({}),
    serverErrors: Proptypes.shape({}),
    autoFocus   : Proptypes.bool,
    placeholder : Proptypes.string,
    disabled    : Proptypes.bool,
    control     : Proptypes.any.isRequired,
    className   : Proptypes.string,
    required    : Proptypes.bool
};
